import { Grid, NumberInput, Space } from '@mantine/core';
import type { Dispatch } from 'react';
import { useAfterVatForm } from '../hooks/useAfterVatForm';
import type { AfterVat, VatReturnInputs } from '../types/VatReturn';
import { ButtonOrCancel } from './VatReturnExportModal';

interface ExcludingVatFormProps {
	setSelectedPage: Dispatch<React.SetStateAction<number>>;
	setInputsInParent: Dispatch<React.SetStateAction<VatReturnInputs>>;
	currentAfterVats?: AfterVat;
}

export function ExcludingVatForm({
	setSelectedPage,
	setInputsInParent,
	currentAfterVats,
}: ExcludingVatFormProps) {
	const { form, inputs } = useAfterVatForm(currentAfterVats);

	return (
		<form
			onSubmit={form.onSubmit(() => {
				form.validate();
			})}
		>
			<Grid>
				<Grid.Col span={12}>
					<NumberInput
						label={'Total Value of Sales Excluding VAT'}
						placeholder="Total value of sales and all other outputs excluding VAT (including supplies to EC)..."
						prefix="£ "
						allowNegative={false}
						decimalScale={2}
						fixedDecimalScale
						key={form.key('valueOfSalesExcVat')}
						{...form.getInputProps('valueOfSalesExcVat')}
					/>
				</Grid.Col>
				<Grid.Col span={12}>
					<NumberInput
						label={'Total Value of Purchases Excluding VAT'}
						placeholder="Total value of purchases and all other inputs excluding VAT (including acquisitions from EC)..."
						prefix="£ "
						allowNegative={false}
						decimalScale={2}
						fixedDecimalScale
						key={form.key('valueOfPurchasesExcVat')}
						{...form.getInputProps('valueOfPurchasesExcVat')}
					/>
				</Grid.Col>
				<Grid.Col span={12}>
					<NumberInput
						label={'Total Value of Supplies Excluding VAT to EC'}
						placeholder="Total value of all supplies of goods, excluding any VAT, to other EC Member States..."
						prefix="£ "
						allowNegative={false}
						decimalScale={2}
						fixedDecimalScale
						key={form.key('valueOfSalesExcVatToEc')}
						{...form.getInputProps('valueOfSalesExcVatToEc')}
					/>
				</Grid.Col>
				<Grid.Col span={12}>
					<NumberInput
						label={'Total Value of Acquisitions Excluding To EC'}
						placeholder="Total value of all acquisitions of goods, excluding any VAT, from EC Member States..."
						prefix="£ "
						allowNegative={false}
						decimalScale={2}
						fixedDecimalScale
						key={form.key('valueOfPurchasesExcVatToEc')}
						{...form.getInputProps('valueOfPurchasesExcVatToEc')}
					/>
				</Grid.Col>
			</Grid>
			<Space h={20} />
			<ButtonOrCancel
				onGoBack={() => setSelectedPage(1)}
				onClick={() => {
					if (form.isValid()) {
						setInputsInParent((prevInputs) => ({
							...prevInputs,
							afterVat: inputs,
						}));
						setSelectedPage(3);
					}
				}}
			/>
		</form>
	);
}
